// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"tn-z","landingPageVideo":"un-z","play":"vn-z","iframeVideo":"wn-z","playHidden":"xn-z","fullwidth":"yn-z"};